<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Persona Avatar Group"
    seFeDataSubtitle="A group of persona avatars"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component for displaying a group of persona avatars that will link to their household side panel</p>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-persona-avatar-group-example [profiles]="profiles"></se-po-persona-avatar-group-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
